var map = {
	"./IMG_1_SEDE.png": 69090,
	"./IMG_2_SEDE.png": 76551,
	"./IMG_3_SEDE.png": 10068,
	"./IMG_4_SEDE.png": 87233,
	"./IMG_5_SEDE.png": 31102,
	"./IMG_ABRE_SEDE.png": 60923
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37218;